<template>
  <div>
    <b-skeleton-wrapper :loading="isLoading">
      <!-- v-if="layout.key == 'serviceScheduler'" -->
      <template #loading>
        <b-row>
          <b-col md="4">
            <b-card>
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton-img no-aspect height="430px" class="mt-3"></b-skeleton-img>
            </b-card>
          </b-col>
          <b-col md="8">
            <b-card>
              <b-skeleton width="85%"></b-skeleton>
              <b-skeleton width="55%"></b-skeleton>
              <b-skeleton-img no-aspect height="430px" class="mt-3"></b-skeleton-img>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <div class="mc-dashboard-geofence">
        <b-row>
          <b-col md="12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div>
                    <h5 class="font-size-13 teal-400 mb-1">
                      {{ $t('dashboard.status.service') }}
                    </h5>
                    <p class="font-size-10 teal-200 mb-0">
                      {{ momentDateShortMonth(new Date()) }}
                      {{ '(' + $t('global.time.today') + ')' }}
                    </p>
                  </div>
                </div>
                <div class="mc-dashboard-card mt-2">
                  <div v-if="!serviceStatuses" class="mc-nodata__section">
                    <!-- <figure class="mc-nodata__section-figure">
                    <img src="@/assets/images/nodata.png" alt />
                  </figure>
                  <p class="mc-nodata__section-text">
                    {{ $t('dashboard.text.noFleetInGeolocation') }}
                  </p> -->
                  </div>
                  <div v-else>
                    <span v-for="(row, index) in serviceStatus" :key="index">
                      <div class="card my-0" @click="openModal(row)">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-9">
                              <p class="text-muted">{{ row.label }}</p>
                              <h5>{{ serviceStatuses[row.key] }}</h5>
                            </div>
                            <div class="avatar-sm">
                              <div
                                :class="`avatar-title rounded-circle bg-${row.color} font-size-20`"
                              >
                                <i :class="`icon-${row.icon}`"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-skeleton-wrapper>
    <ModalStatusService
      ref="modalStatusService"
    />
  </div>
</template>

<script>
import ModalStatusService from './ModalStatusService'
import { GET_SERVICE_SCHEDULES_BY_VEHICLE } from '@/services/api/maintenance/serviceSchedules'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    ModalStatusService,
  },

  mixins: [Helper],

  apollo: {
    serviceSchedulesByVehicle: {
      client: 'clientLowPrio',
      query: GET_SERVICE_SCHEDULES_BY_VEHICLE,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (data) {
          this.serviceStatuses = data.serviceSchedulesByVehicle.serviceSchedulesByVehicle.aggregate
          this.isLoading = loading
        }
      },
    },
  },

  data() {
    return {
      serviceStatuses: [],
      modalWidgetServieScheduler: false,
      title: '',
      isLoading: true,
      modal: true,
      vgroupId: null,
    }
  },

  computed: {
    serviceStatus() {
      return [
        {
          key: 'vehiclesAsInProgress',
          label: this.$t('maintenance.status.inService'),
          icon: 'outline_truck-maintenance',
          color: 'info',
          status: 'inProgress',
        },
        {
          key: 'vehiclesAsLate',
          label: this.$t('maintenance.status.lateService'),
          icon: 'outline_alert-triangle',
          color: 'danger',
          status: 'late',
        },
        {
          key: 'vehiclesAsSoon',
          label: this.$t('maintenance.status.approachingService'),
          icon: 'outline_timer',
          color: 'warning',
          status: 'soon',
        },
        {
          key: 'vehiclesAsNormal',
          label: this.$t('maintenance.status.normal'),
          icon: 'outline_checkmark-circle-2',
          color: 'success',
          status: 'normal',
        },
      ]
    },
  },

  mounted() {
    this.$apollo.queries.serviceSchedulesByVehicle.refetch()
  },

  methods: {
    async loadServiceScheduler(vgroupId) {
      this.isLoading = true
      this.vgroupId = vgroupId
      await this.$apollo.queries.serviceSchedulesByVehicle.refetch({
        filter: {
          vgroupId,
        },
      })
    },
    async openModal(row) {
      await this.$refs.modalStatusService.loadServiceScheduleVehicles(
        row,
        this.vgroupId ?? undefined
      )
      setTimeout(() => {
        this.$bvModal.show('modal-service-status')
      }, 10)
    },
  },
}
</script>
